const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} pago · {{freeQuantity}} × grátis',
  all_free: '{{freeQuantity}} × grátis',
};

export default OfferLineBreakdown;
